import { appendVueRoute } from '@therame/shared';
import { type RouteRecordRaw } from 'vue-router';

/**
 * Public Steuerberater route. Rendered without keycloak — the only
 * authorisation is the signed `token` path parameter, which the view
 * forwards in the `x-steuerberater-token` header on every API call.
 */
const routes: Array<RouteRecordRaw> = [
  {
    ...appendVueRoute<'steuerberaterPublicDatev'>(
      'steuerberaterPublicDatev',
      '/steuerberater-datev/:token',
    ),
    component: () => import('@src/views/SteuerberaterPublicDatevSettings.vue'),
    meta: {
      layout: 'none',
      title: 'DATEV-Einstellungen',
      hideTitle: true,
      requiresAuth: false,
      requiresOnboarding: false,
    },
  },
];

export default routes;
